var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"header default-gutter",attrs:{"align-center":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"white"}},[_vm._v("mdi-history")]),_c('div',[_vm._v("Decision Aid: "),_c('span',[_vm._v("Change Summary")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }